import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { updateMessages } from 'apps/auth/actions/appAction';
import { deleteCard } from 'apps/auth/actions/cardsAction';
import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { setNewForm } from 'apps/auth/actions/formAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import Form from 'apps/auth/components/form-multi/Form';
import { getField } from 'apps/auth/components/form-multi/utils';
import update from 'apps/auth/helpers/Immutability';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const FORM_NAME = 'deleteCardPopup';

const DeleteCardPopup = (props) => {
    const { removeCardButton, cardExpiredText, defaultBankName } = usePageMessages();

    const { linkedCards } = useExtra();

    useEffect(() => {
        const selectedCard = props.selectedCard;
        const cardIdField = getField('id', selectedCard.id);

        props.setNewForm(FORM_NAME, {
            [cardIdField.name]: cardIdField,
        });
    }, []);

    const customDeleteCard = (id, sources) => {
        const source = Object.values(sources).find((s) => s.id === id);
        const newSources = update(sources, { $unset: [source.id] });
        return props.updateExtraByName('linkedCards', newSources);
    };

    const onSubmitHandler = (fields, json) => {
        if (props.popupRef?.current) {
            props.popupRef.current?.close();
        }
        if (json.messageBodyMessages) {
            updateMessages(json.messageBodyMessages);
        }

        customDeleteCard(props.selectedCard.id, linkedCards);
    };

    return (
        <Form
            action={'/auth/plus/remove/card.action'}
            formName={FORM_NAME}
            validateForm={false}
            onSubmitHandler={onSubmitHandler}
            beforeSubmit={(e) => {
                e.stopPropagation();
                props.popupRef?.current?.close();
            }}
        >
            <SimplePopup
                popupRef={props.popupRef}
                text={resolveArguments(cardExpiredText, `${props.selectedCard.bankName || defaultBankName} ·· ${props.selectedCard.description}`)}
            >
                <PopupButton iconName="cross" type="submit" text={removeCardButton} />
            </SimplePopup>
        </Form>
    );
};

export default connect(null, {
    setNewForm,
    deleteCard,
    updateMessages,
    updateExtraByName,
})(DeleteCardPopup);
